export default __webpack_public_path__ + "static/media/gallery-wip-handle_05.2a49977f.jpg";